import { Avatar } from '@mui/material';

interface UsesrAvatarProps {
  src: string | undefined;
  alt?: string | null;
};

export const UserAvatar = ({ src, alt }: UsesrAvatarProps) => {
  return (
    <Avatar
      alt={alt ?? 'User Avatar'}
      src={src} sx={{
        width: '260px',
        height: '260px',
        borderRadius: '10px',
        '& .MuiAvatar-fallback': { width: '100px' }
      }}
    />
  );
};

export default UserAvatar;
